import React from 'react'
import { Row, Col, TimePicker, Collapse, Card, Avatar, Tooltip } from 'antd'
import './WidgetInstanceItem.css'
import ActionButton from '../components/ActionButton'
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../actions';
const { Panel } = Collapse;

const { Meta } = Card;
function WidgetInstanceItem(props) {
    const { data, onClick = () => { }, onEdit = () => { }, onDelete = () => { }, allowEdit = true, allowDelete = true } = props

    const { WidgetInstanceName, WidgetKey, WidgetID, WidgetCover } = data


    // console.log("parseInt(Timelinelayouts.Duration) " + moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format('HH:mm:ss'))
    return (
        <Row className="item-container" style={{ width: "100%" }} >
            <Col flex="10px" style={{ backgroundColor: data.color, borderRadius: "6px", minHeight: "40px" }}></Col>
            <Col span={22}>
                <Row className="aloha" gutter={[8, 8]} align="middle" justify="space-around" style={{ margin: "0px" }}>
                    <Col xs={21} sm={21} md={21} lg={21} xl={21} style={{ display: "flex", alignItems: "center" }}>
                        <img style={{ width: "80px", height: "80px", display: "inline-block", marginRight: "16px", cursor: "pointer" }} onClick={onClick} src={WidgetCover}></img>
                        <Tooltip title={WidgetInstanceName}>
                            <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", fontWeight: 500, color: "#0f172a", fontSize: "14px" }}><a style={{ color: "#0f172a" }} onClick={onClick}>{WidgetInstanceName}</a></div>
                        </Tooltip>
                    </Col>
                    {/* <Col xs={9} sm={9} md={9} lg={9} xl={2}>
                        <TimePicker onChange={onDurationChanged} className="duration-picker" size="medium" allowClear={false} defaultValue={momentDuration} bordered={false} showNow={false} placeholder="Duration" /></Col> */}
                    <Col xs={3} sm={3} md={3} lg={3} xl={3} style={{ textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <ActionButton danger={true} visible={allowEdit} confirmText="Are you sure you want to delete this widget instance?" onClicked={() => onDelete(WidgetID)} title="Delete" showTitle={false} icon="/cms/assets/svgs/icons/trash_icon.svg"></ActionButton>
                        <ActionButton onClicked={() => onEdit(WidgetID)} visible={allowDelete} title="Edit" showTitle={false} icon="/cms/assets/svgs/icons/edit_icon.svg"></ActionButton>
                        {/* <ActionButton onClicked={() => onDuplicate(TimelineID)} title="Duplicate" showTitle={false} icon="/cms/assets/svgs/icons/duplicate_icon.svg"></ActionButton> */}
                    </Col>
                </Row>
            </Col>
            {/* <Col className="column-drag-handle" span={1} style={{ display: "flex", cursor: "pointer", alignItems: "center", pointerEvents: (allowEdit ? "auto" : "none") }}>
                <span style={{ display: "inline-block", pointerEvents: "none" }}>&#x2630;</span>
            </Col> */}
        </Row >
    )
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(WidgetInstanceItem);
